import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

export type EditButtonClasses = 'image' | 'button' | 'buttonLabel' | 'noBorder' | 'large' | 'small';

const editButtonStyles = makeStyles<ISpcTheme, EditButtonClasses>(
  ({ palette }) => ({
    image: {
      position: 'absolute',
      height: '75%',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%) rotate(180deg)',
    },
    buttonLabel: {
      '& div': {
        background: 'transparent !important',
        padding: 'initial !important',
        position: 'static !important',
      },
    },
    button: {
      display: 'block',
      borderRadius: '9999px',
      minWidth: '20px',
      position: 'relative',
      border: `2px solid ${palette.primary.main}`,
      backgroundColor: 'transparent',
      transition: 'border .2s, background-color .2s',
      margin: '0 2px 0 5px',

      '&:hover': {
        borderColor: palette.primary.dark,
      },
      '&:active': {
        borderColor: palette.primary.dark,
      },
      '&:disabled': {
        borderColor: palette.primary.light,
        cursor: 'default',
      },
    },
    noBorder: {
      border: 'none',
    },
    large: {
      width: '35px',
      height: '35px',
      margin: 0,
    },
    small: {
      width: '20px',
      height: '20px',
    },
  }),
  { name: 'SPC_EditSettingsButton' },
);

export default editButtonStyles;
